import { Component, OnInit, AfterContentInit, ViewChild, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { LCA } from 'src/app/data/models/lca.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import moment from 'moment';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { LcaService } from 'src/app/services/lca.service';
import { PostLcaComponent } from '../post-lca/post-lca.component';
import { ActionAlertModalComponent } from '../action-alert-modal/action-alert-modal.component';
import { ViewPostedLcaComponent } from '../view-posted-lca/view-posted-lca.component';
import { WithdrawLcaComponent } from '../withdraw-lca/withdraw-lca.component';
import { I9ADMIN } from 'src/app/data/constants/roles';


@Component({
    selector: 'app-lca-list',
    templateUrl: './lca-list.component.html',
    styleUrls: ['./lca-list.component.scss']
})
export class LcaListComponent implements OnInit, AfterContentInit {

    lcaList: LCA[] = [];
    postedLcaList: LCA[] = [];
    archivedLcaList: LCA[] = [];
    displayedColumns: string[] = [];
    postedLcaDisplayedColumns: string[] = [];
    archivedLcaDisplayedColumns: string[] = [];
    //  This will go as separate release as an enhancement
    // auditLcaDisplayedColumns:string[] = [];
    dataSource: MatTableDataSource<any>;
    postedLcaDataSource: MatTableDataSource<any>;
    archivedLcaDataSource: MatTableDataSource<any>;

    pageEvent: PageEvent;
    pageSizeOptions = [25, 50, 100]
    pageIndex: number = 1;//default
    pageSize: number = 25;//default
    totalRecordCount: number = 0;
    totalPostedLcaRecordCount: number = 0;
    totalArchivedLcaRecordCount: number = 0;
    dateRangeForm: FormGroup;
    validityEndDate;
    validityStartDate;
    subscriptions: Subscription[] = [];
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) postedLcaPaginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) postedLcaSort: MatSort;
    @ViewChild(MatPaginator, { static: true }) archivedLcaPaginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) archivedLcaSort: MatSort;
    selectedTabIndex = 0;
    filterData: any;
    filterForm: FormGroup;
    statusOptions: string[] = ['Assigned', 'Certified', 'Not Certified', 'Withdrawn', 'Live', 'Take Down', 'E-Filed', 'External Filed'];
    showFilterButton = true;
    isI9Admin: boolean = false;

    columns = [
        { columnDef: 'caseNumber', header: 'Case No.', columnType: 'text', customClass: '' },
        { columnDef: 'jobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
        { columnDef: 'socCode', header: 'SOC Code', columnType: 'text', customClass: '' },
        { columnDef: 'employmentStartDate', header: 'Start', columnType: 'text', customClass: '' },
        { columnDef: 'employmentEndDate', header: 'End', columnType: 'text', customClass: '' },
        { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
        { columnDef: 'visaType', header: 'Visa Type', columnType: 'text', customClass: '' },
        { columnDef: 'comment', header: 'Notes', columnType: 'text', customClass: 'mat-cell-wrap-text' },
        { columnDef: 'status', header: 'Status', columnType: 'text', customClass: '' },
        { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
    ];

    postedLcaColumns = [
        { columnDef: 'caseNumber', header: 'Case No.', columnType: 'text', customClass: '' },
        { columnDef: 'jobTitle', header: 'Job Title', columnType: 'text', customClass: '' },
        { columnDef: 'location', header: 'Location', columnType: 'text', customClass: '' },
        { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
        { columnDef: 'visaType', header: 'Visa Type', columnType: 'text', customClass: '' },
        { columnDef: 'postedDate', header: 'Posted Date', columnType: 'text', customClass: '' },
        { columnDef: 'daysPosted', header: 'Days Posted', columnType: 'text', customClass: '' },
        { columnDef: 'status', header: 'Status', columnType: 'text', customClass: '' },
        { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
    ];

    archivedLcaColumns = [
        { columnDef: 'archivedDate', header: 'Archived Date', columnType: 'text', customClass: '' },
        { columnDef: 'caseNumber', header: 'Case No.', columnType: 'text', customClass: '' },
        { columnDef: 'jobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
        { columnDef: 'location', header: 'Location', columnType: 'text', customClass: '' },
        { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
        { columnDef: 'visaType', header: 'Visa Type', columnType: 'text', customClass: '' },
        { columnDef: 'daysPosted', header: 'Days Posted', columnType: 'text', customClass: '' },
        { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
    ];
    

    //  This will go as separate release as an enhancement
    // auditLcaColumns = [
    //   { columnDef: 'caseNumber', header: 'LCA Case number', columnType: 'text', customClass: '' },
    //   { columnDef: 'visaClassification', header: 'Visa classification basis', columnType: 'text', customClass: '' },
    //   { columnDef: 'location', header: 'Worksite Location', columnType: 'text', customClass: '' },
    //   { columnDef: 'wageRate', header: 'Prevailing wage rate', columnType: 'text', customClass: '' },
    //   { columnDef: 'wagePaid', header: 'Actual wage paid', columnType: 'text', customClass: '' },
    //   { columnDef: 'startDate', header: 'LCA posting start date', columnType: 'text', customClass: '' },
    //   { columnDef: 'endDate', header: 'LCA posting end date', columnType: 'text', customClass: '' },
    //   { columnDef: 'lcaPosting', header: 'Evidence for LCA Posting', columnType: 'text', customClass: '' },
    //   { columnDef: 'lcaAcknowledgement', header: 'Evidence for LCA acknowledgment', columnType: 'text', customClass: '' },
    //   { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
    // ];
    userId: string;
    companyId: string;
    userType: string;
    filterModalComponent: any;
    filterBoxVisible = false;


    //  This will go as separate release as an enhancement
    // auditLogList:any=[];   
    // totalAuditRecordCount:any;         
    // auditLcaDataSource:any=[]; 

    constructor(
        private lcaService: LcaService,
        private router: Router,
        private route: ActivatedRoute,
        private petitionerService: PetitionerService,
        private toastService: ToastrService,
        public dialog: MatDialog,
        private fb: FormBuilder
    ) {
        this.filterForm = this.fb.group({
            caseId: [''],
            status: [''],
            startDate: [''],
            endDate: [''],
        });
    }

    ngOnInit() {
        sessionStorage.removeItem("isDuplicateLCA");
        this.userId = sessionStorage.getItem('userId');
        this.companyId = sessionStorage.getItem('companyId');
        this.userType = sessionStorage.getItem('userTypeRole');
        if(this.userType == 'I9Admin'){
            this.isI9Admin = true;
        }
        this.setDisplayedColumns();
        if (this.paginator) {
            this.paginator.pageSize = this.pageSize;
        }
        if (this.postedLcaPaginator) {
            this.postedLcaPaginator.pageSize = this.pageSize;
        }
        if (this.archivedLcaPaginator) {
            this.archivedLcaPaginator.pageSize = this.pageSize;
        }
        this.filterByDateformInit();///keep this above fn call
        this.loadLcaCodes(this.selectedTabIndex);
        this.paginator.page.pipe(tap(() => this.loadLcaCodes(this.selectedTabIndex))).subscribe();
    }

    setDisplayedColumns() {
        // Filter out 'action' column if isI9Admin is true
        this.columns = this.columns.filter(column => (this.isI9Admin && column.columnDef !== 'action') || (!this.isI9Admin));
        this.postedLcaColumns = this.postedLcaColumns.filter(column => (this.isI9Admin && column.columnDef !== 'action') || (!this.isI9Admin));
        this.archivedLcaColumns = this.archivedLcaColumns.filter(column => (this.isI9Admin && column.columnDef !== 'action') || (!this.isI9Admin));
    }

    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.postedLcaDisplayedColumns = this.postedLcaColumns.map(c => c.columnDef);
        this.archivedLcaDisplayedColumns = this.archivedLcaColumns.map(c => c.columnDef);
        //  This will go as separate release as an enhancement
        // this.auditLcaDisplayedColumns = this.auditLcaColumns.map(c => c.columnDef);
    }

    ngAfterViewInit() {
        if (this.dataSource && this.dataSource.paginator) {
          this.dataSource.paginator = this.paginator;
          this.mapSorting();
        }
        if (this.postedLcaDataSource && this.postedLcaDataSource.paginator) {
          this.postedLcaDataSource.paginator = this.postedLcaPaginator;
          this.mapSorting(2);
        }
        if (this.archivedLcaDataSource && this.archivedLcaDataSource.paginator) {
          this.archivedLcaDataSource.paginator = this.archivedLcaPaginator;
          this.mapSorting(3);
        }
      }
      mapSorting(tabNumber: number = 1){
        switch(tabNumber){
          case 1:
            if (this.dataSource) {
              this.dataSource.sort = this.sort;
            }
          case 2:
            if (this.postedLcaDataSource) {
              this.postedLcaDataSource.sort = this.postedLcaSort;
            }
          case 3:
            if (this.archivedLcaDataSource) {
              this.archivedLcaDataSource.sort = this.archivedLcaSort;
            }
        }
      }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    handleClick(path: string) {
        this.router.navigate([path]);
    }

    handleEdit(input, isDuplicate) {
        sessionStorage.setItem("lcaId", input.id);
        sessionStorage.setItem("isCertifiesId", input.status.code);
        sessionStorage.setItem("isDuplicateLCA", isDuplicate ? 'true' : 'false');
        this.router.navigate(['../add-new'], { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }

    handleDelete(input) {
        const title = 'Confirm';
        const message = 'Do you wish to delete the Item?';
        this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {
            if (result) {
                this.petitionerService.deleteLca(input.id).subscribe(data => {
                    this.toastService.success("Deleted successfully!");
                    this.loadLcaCodes(this.selectedTabIndex)
                });
            }
        });
    }

    createNew() {
        sessionStorage.removeItem('lcaId');
        this.router.navigate(['../add-new'],
            { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }
    

    loadLcaCodes(selectedTabIndex) {
        let userTypeVal = (this.userType==='Attorney') ? 'attorney' : 'company';
        let payload = {
          jobTitle: null,
          pageNumber:this.pageIndex || 1,
          pageSize: this.pageSize || 25,
          socCode: null,
          validityEndDate: this.validityEndDate||null,
          validityStartDate:this.validityStartDate||null
        } 
    
        if (selectedTabIndex == 0) {
          this.petitionerService.getLcaCodes(userTypeVal,this.companyId, payload).subscribe(data => {
            this.lcaList = data['lcaApplicationResponseDto'];      
            this.totalRecordCount = data['totalNumberOfRecords'];      
            this.dataSource = new MatTableDataSource(this.lcaList); 
            this.mapSorting();       
          });
        } else if (selectedTabIndex == 1) {
          this.petitionerService.getPostedLcaCodes(userTypeVal,this.companyId, payload).subscribe(data => {
            this.postedLcaList = data['lcaApplicationResponseDto'];      
            this.totalPostedLcaRecordCount = data['totalNumberOfRecords'];      
            this.postedLcaDataSource = new MatTableDataSource(this.postedLcaList);      
            this.mapSorting(2);       
          });
        } else if (selectedTabIndex == 2){
          this.petitionerService.getArchivedLcaCodes(userTypeVal,this.companyId, payload).subscribe(data => {
            this.archivedLcaList = data['lcaApplicationResponseDto'];      
            this.totalArchivedLcaRecordCount = data['totalNumberOfRecords'];         
            this.archivedLcaDataSource = new MatTableDataSource(this.archivedLcaList);      
            this.mapSorting(3);       
          });
        }
    }
    filterByDateformInit() {
        this.dateRangeForm = new FormGroup({
            fromDate: new FormControl(null),
            endDate: new FormControl(null)
        });
        this.subscriptions.push(this.dateRangeForm.get('fromDate').valueChanges.subscribe(val => {
            this.validityStartDate = val;
        }));
        this.subscriptions.push(this.dateRangeForm.get('endDate').valueChanges.subscribe(val => {
            this.validityEndDate = val;
        }));

    }

    loadlistWithDates() {
        this.validityStartDate = this.validityStartDate ? moment(this.validityStartDate).format("YYYY-MM-DD") : null;
        this.validityEndDate = this.validityEndDate ? moment(this.validityEndDate).format("YYYY-MM-DD") : null;
        //validation 
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = this.pageSize;
        this.loadLcaCodes(this.selectedTabIndex)
    }

    paginationEvent(event: PageEvent) {
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.loadLcaCodes(this.selectedTabIndex)
    }

    openPostLcaModal(lcaData) {
        this.dialog.open(PostLcaComponent, {
            width: '680px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.loadLcaDtails(this.selectedTabIndex);
            }
        });
    }

    viewPostedLCA(lcaData) {
        this.dialog.open(ViewPostedLcaComponent, {
            width: '680px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            return;
        });
    }

    editPostedLCA(lcaData) {
        this.dialog.open(PostLcaComponent, {
            width: '680px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.loadLcaDtails(this.selectedTabIndex);
            }
        });
    }
    
    takeDownLCA(lcaData) {      
      this.petitionerService.takeDownLCA(lcaData.lcaAppId).subscribe(data => {
        this.toastService.success("LCA Taken Down successfully!", 'Success');
        this.loadLcaDtails(this.selectedTabIndex);
      });
    }

    archiveLCA(lcaData) {
        this.petitionerService.archiveOrRestoreLCA(lcaData.lcaAppId, this.companyId, true).subscribe(data => {
            this.toastService.success("LCA archived successfully!", 'Success');
            this.loadLcaDtails(this.selectedTabIndex);
        });
    }

    restoreArchivedLCA(lcaData) {
        this.petitionerService.archiveOrRestoreLCA(lcaData.id, this.companyId, false).subscribe(data => {
            this.toastService.success("LCA restored successfully!", 'Success');
            this.loadLcaDtails(this.selectedTabIndex);
        });
    }

    deleteArchivedLCA(lcaData) {
        this.petitionerService.deleteArchivedLca(lcaData.id, this.companyId).subscribe(data => {
            this.toastService.success("LCA deleted successfully!", 'Success');
            this.loadLcaDtails(this.selectedTabIndex);
        });
    }

    onTabChanged(event: any): void {
        this.updateStatusOptions(event.index);
        this.showFilterButton = this.shouldShowFilterButton(event.index);
        this.selectedTabIndex = event.index;
        this.filterForm.reset();
        this.filterData = '';
        switch (this.selectedTabIndex) {
            case 0:
                this.loadLcaDtails(this.selectedTabIndex);
                break;
            case 1:
                this.loadLcaDtails(this.selectedTabIndex);
                break;
            case 2:
                this.loadLcaDtails(this.selectedTabIndex);
                break;
            case 3:
                this.loadLcaDtails(this.selectedTabIndex);
                break;
            default:
                break;
        }
    }

    updateStatusOptions(selectedTab: number): void {
        if (selectedTab === 0) {
            this.statusOptions = ['Assigned', 'Certified', 'Not Certified', 'Withdrawn', 'Live', 'Take Down', 'E-Filed', 'External Filed'];
        } else if (selectedTab === 1) {
            this.statusOptions = ['Live', 'Take Down'];
        } else {
            this.statusOptions = [];
        }
    }

    shouldShowFilterButton(selectedTab: number): boolean {
        return selectedTab === 0 || selectedTab === 1;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    dialogueInitializer(event, title: string, message: string) {
        const cordinates: MouseEventInit = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }

    openActionAlertModal(lcaData, action: string) {
        const dialogRef = this.dialog.open(ActionAlertModalComponent, {
            width: '580px',
            data: {
                lcaData: lcaData,
                action: action,
                buttons: ['Cancel', action]
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                if (action == 'archive') {
                    this.archiveLCA(lcaData);
                } else if (action == 'take down') {
                    this.takeDownLCA(lcaData);
                } else if (action == 'delete') {
                    this.deleteArchivedLCA(lcaData);
                }
            }
        });
    }

    loadLcaDtails(selectedTabIndex) {
        const payload = {
            "caseId": this.filterData?.caseId,
            "jobTitle": "",
            "pageNumber": 1,
            "pageSize": this.pageSize || 25,
            "socCode": "",
            "status": this.filterData?.status,
            "validityEndDate": this.filterData?.endDate ? moment(this.filterData?.endDate).format('YYYY-MM-DD') : null,
            "validityStartDate": this.filterData?.startDate ? moment(this.filterData?.startDate).format('YYYY-MM-DD') : null
        };
        let userTypeVal = (this.userType === 'Attorney') ? 'attorney' : 'company';

        if (selectedTabIndex == 0) {
            this.petitionerService.getLcaCodes(userTypeVal, this.companyId, payload).subscribe(data => {
                this.lcaList = data['lcaApplicationResponseDto'];
                this.totalRecordCount = data['totalNumberOfRecords'];
                this.dataSource = new MatTableDataSource(this.lcaList);
            });
        } else if (selectedTabIndex == 1) {
            this.petitionerService.getLcaPostedfilterDetails(this.companyId, payload).subscribe(data => {
                this.postedLcaList = data['lcaApplicationResponseDto'];
                this.totalPostedLcaRecordCount = data['totalNumberOfRecords'];
                this.postedLcaDataSource = new MatTableDataSource(this.postedLcaList);
            });
        } else if (selectedTabIndex == 2) {
            this.petitionerService.getLcaArchivedfilterDetails(this.companyId, payload).subscribe(data => {
                this.archivedLcaList = data['lcaApplicationResponseDto'];
                this.totalArchivedLcaRecordCount = data['totalNumberOfRecords'];
                this.archivedLcaDataSource = new MatTableDataSource(this.archivedLcaList);
            });
        }

        //  This will go as separate release as an enhancement

        // else if (selectedTabIndex == 3){
        //   // this.petitionerService.getLcaArchivedfilterDetails(this.companyId, payload).subscribe(data => {
        //     this.auditLogList = 
        //   [{
        //      'caseNumber': 3433443,
        //      'visaClassification': 'Yes',
        //      'location': 'Mumbai',
        //      'wageRate': 2.5,
        //      'wagePaid': 5000,
        //      'startDate': '2023-10-10',
        //      'endDate': '2024-02-10',
        //      'lcaPosting': 'Yes',
        //      'lcaAcknowledgement': 'Yes'
        //  },
        //  {
        //      'caseNumber': 8977545,
        //      'visaClassification': 'No',
        //      'location': 'Delhi',
        //      'wageRate': 1.2,
        //      'wagePaid': 3000,
        //      'startDate': '2023-10-10',
        //      'endDate': '2024-02-10',
        //      'lcaPosting': 'No',
        //      'lcaAcknowledgement': 'No'
        //  }];
        //   this.totalAuditRecordCount = 2;         

        //   this.auditLcaDataSource = new MatTableDataSource(this.auditLogList); 
        //   // });        
        // }
    }

    openFilterBox() {
        this.filterBoxVisible = !this.filterBoxVisible;
    }

    applyAdvanceFilter() {
        this.filterData = this.filterForm.value;
        this.loadLcaDtails(this.selectedTabIndex);
        this.filterBoxVisible = false;
        this.filterForm.reset();
    }


    openWithdrawLcaModal(lcaData) {
        this.dialog.open(WithdrawLcaComponent, {
            width: '800px',
            data: lcaData
        }).afterClosed().subscribe(response => {
            if (response == true) {
                this.loadLcaDtails(this.selectedTabIndex);
            }
        });
    }

    handleView(input) {
        sessionStorage.setItem("lcaId", input.id);
        sessionStorage.setItem("isCertifiesId", input.status.code);
        this.router.navigate(['../view-lca-details'], { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }

    updateLcaDecision(lcaData) {
        sessionStorage.setItem("lcaId", lcaData.id);
        sessionStorage.setItem("isCertifiesId", lcaData.status.code);
        this.router.navigate(['../update-lca-decision'], { relativeTo: this.route, state: { redirectUrl: '../lca', redirectPage: 'Back to Lca List' } });
    }

}
